
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import VueCookies from 'vue-cookies';
  import { mapGetters } from 'vuex';

  import Input from '@/components/Core/Input.vue';

  import { IErrorModel } from '@/models/errors.model';
  import { ILoginModel, ILoginPasswordResultModel, ILoginPasswordModel } from '@/models/login.model';

  import tokenService from '@/services/token.service';
  import accountService from '@/services/account.service';

  Vue.use(VueCookies);

  @Component({
    components: {
      Input
    },
    computed: {
      ...mapGetters([
        'isLoading'
      ])
    }
  })
  export default class LoginPassword extends Vue {
    @Prop({ type: Object as () => ILoginModel })
    public user!: ILoginModel;

    data() {
      return {
        isLoginLoading: false,
        hasErrors: false,
        errors: new Array<IErrorModel>()
      }
    };

    logIn() {
      if (this.$data.isLoginLoading) {
        return;
      }

      this.$store.dispatch("updateIsLoading", true);
      this.$data.isLoginLoading = true;
      this.$data.errors = new Array<IErrorModel>();
      this.$data.hasErrors = false;

      setTimeout(() => {
        const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "log/user/" + this.user.Id_User + "/log-in";

        accountService.post<ILoginPasswordModel, ILoginPasswordResultModel>(this, url, { Password: this.user.Password })
          .then(response => {
            const now = new Date();
            this.$cookies.set("_g2g_identity_", response.Created, new Date(now.setDate(now.getDate() + 30)), undefined, undefined, undefined, "Strict");

            this.$data.isLoginLoading = false;
            tokenService.setToken(this, true);
          })
          .catch(error => {
            this.$data.hasErrors = true;
            this.$data.isLoginLoading = false;
            this.$data.errors = error.data.ErrorMessages;
            this.$store.dispatch("updateIsLoading", false);
          });
      }, 300);
    }

    goToLoginView() {
      this.$emit('update:view', 'LoginHome');
    }

    updatePasswordValue(parameterName: string, value: string) {
      this.user.Password = value;
    }
  }
